import { VueExtension } from '../../utils/extensions/vue';
import Picker from './picker.jsx';
import './picker.scss';

VueExtension.WithInstall(Picker);

export default Picker;
